import React, { Component } from 'react'
import IncompleteLeadsUi from '../../../presentationals/Admin/LeadManagementNew/IncompleteLeads.component'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {
    getManagementLeadApiOptimized, getUserDetailByLoanIdOptimisedApi, saveImportantLoans,
    getlistByApplication, getlistByEmail, getistByNumber, pushNotification, saveNachDataApi, getWhatsappMsgApi, getCommentsApi, getLeadManagmentCountsApi, logAdminApi, FetchLeadManagementData, getLeadManagmentStatsApi
} from '../AdminActionCreator.component'
import MainDetailsPopup from '../CustomerPages/MainDetailPopup.container'
import UserDetail from '../CustomerPages/UserDetailMainNew.container';
// import { STRING } from '../../../../utils/Constant'
import { _preFormatDate } from '../../../../utils/validation'
import { APIS } from '../../../../utils/api-factory'
import DotLoader from '../../../presentationals/Loader/layerLoader.component'
import moment from 'moment';
import Popup from '../../../presentationals/Popup/Popup.component';
import { STRING, ROLE } from '../../../../utils/Constant'
import WhatsAppPopup from '../../../presentationals/Popup/WhatsApp.popup'

let paginationNumber = 10

let leadType = "incomplete"
let nachCheckbox = false
let interval;
let itemsPerPage = 10;

class IncompleteLeads extends Component {
    constructor(props) {
        super(props);
        this.state = {
            FilteredData: [],
            pageIndexToShow: 0,
            allUserDetail: [],
            userState: true,
            viewState: false,
            allDetail: [],
            userDetail: [],
            loadarState: false,
            forwordPageState: 1,
            followUpStatus: STRING.SELECT_ALL,
            dataFilterState: {
                searchByAppNo: '',
                searchByemail: '',
                searchBymobile: '',
                searchByDate: moment(new Date()).subtract(7, 'days').format('DD-MM-YYYY'),
                searchByDateShow: '',
                searchByendDate: moment(new Date()).format("DD-MM-YYYY"),
                searchByEndDateShow: '',
                // salaryRange: '>=30000'
                salaryRange: ''

            },
            whatsappPopupState: false,
            whatsapMsgToShow: '',
            todaysApplicationNo: '',
            markCompleteBtn: true,
            countforstatus: '',
            commentType: '',
            popupStatus: '',
            commentStateSelect: '',
            popupState: false,
            tableMinPagination: 0,
            tableMaxPagination: paginationNumber,
            forwordPageState: 1,
            // startDate: moment(new Date()).format("DD-MM-YYYY"),
            startDate: moment(new Date()).subtract(7, 'days').format('DD-MM-YYYY'),
            leadComment: '',
            actionButtonState: true,
            dataChange: '',
            commentsData: [],
            endDate: moment(new Date()).format("DD-MM-YYYY"),
            countType: 'incomplete',
            leadManagementCounts: {},
            bucketStage: 'default',
            pageNumber: 1,
            LeadData: [],
            totalLeadData: 0,




        }
    }
    handleChangeNewPagination(e, value) {
        this.setState({ pageNumber: value }, () => this.getLoanLead())
        const newMinPagination = (value - 1) * paginationNumber;
        const newMaxPagination = value * paginationNumber;
        this.setState({
            tableMinPagination: newMinPagination,
            tableMaxPagination: newMaxPagination,
        });
    };
    getCount(sDate, eDate) {
        const { admin } = this.props
        // getLeadManagmentCountsApi(admin.emailId, this.state.startDate, this.state.countType, this.state.endDate, this.state.bucketStage, callBack => {
        //     console.log(callBack)
        //     this.setState({ leadManagementCounts: callBack })
        // })
                const roleApi = this.props.handleRoleForApi()
        getLeadManagmentStatsApi(admin.emailId, sDate, this.state.countType, eDate, this.state.bucketStage,roleApi, callBack => {
            console.log(callBack)
            if (callBack && callBack?.message == "success" && callBack?.status == 200) {
                this.setState({ leadManagementCounts: callBack?.data })
            } else {
                this.setState({ leadManagementCounts: {} })
            }
        })
    }
    getCountForStatus() {
        const { admin } = this.props

        fetch(APIS.GET_DASHBOARD_COUNT_FOR_STATUS + admin.emailId + '&startDate=' + this.state.startDate + '&endDate=' + this.state.startDate + '&status=' + admin.department)
            .then(res => res.json())
            .then(res => {
                this.setState({ countforstatus: res })
            })
    }
    componentDidMount() {
        this.getCount(this.state.startDate, this.state.endDate)
        interval = setInterval(function () {
            let dataFilterState = Object.assign({}, this.state.dataFilterState)
            // dataFilterState.salaryRange = data ? data : ''
            // this.setState({ loadarState: true })
            if (this.state.viewState === false) {

                // this.props.getManagementLeadApiOptimized(leadType, this.state.followUpStatus, this.state.forwordPageState, this.props.admin.emailId, this.state.dataFilterState.searchByDate, this.state.commentType, this.state.dataFilterState.salaryRange, this.state.bucketStage,
                //     (callBack) => {
                //         this.setState({ loadarState: false })

                //     })
                 const roleApi = this.props.handleRoleForApi()
                this.props.FetchLeadManagementData(leadType, this.state.followUpStatus, this.state.pageNumber, this.props.admin.emailId, this.state.dataFilterState.searchByDate, this.state.commentType, this.state.dataFilterState.salaryRange, this.state.bucketStage, this.state.dataFilterState.searchByendDate, itemsPerPage, "", "", "",roleApi,
                    (callBack) => {
                        this.setState({ loadarState: false, LeadData: callBack?.data?.loanList, totalLeadData: callBack?.data?.totalCount })
                    })
            }
        }.bind(this), 30000) // 5 min
    }
    getComments() {

        getCommentsApi(leadType, this.state.followUpStatus, this.state.forwordPageState, this.props.admin.emailId, this.state.dataFilterState.searchByDate, this.state.commentType, this.state.dataFilterState.salaryRange, this.state.bucketStage, callBack => {
            this.setState({ commentsData: callBack })

        })
    }
    componentWillUnmount() {
        clearInterval(interval);
    }
    componentWillMount() {
        localStorage.setItem('showComment', 'yes')
        // this.getCountForStatus()

        this.getLoanLead(this.state.dataFilterState.salaryRange)
        // fetch(APIS.TODAYS_LOAN_COUNT + "&type=" + leadType)
        //     .then(res => res.json())
        //     .then(json => {
        //         this.setState({ todaysApplicationNo: json })
        //     })
    }
    userCommentSelect(e) {
        this.setState({ commentStateSelect: e.target.value })

    }


    userCommentHandler(data) {
        const { admin } = this.props
        pushNotification(data, this.state.commentStateSelect, '', admin.emailId, "comment", '', '', '', '', '',
            (callBack) => {
                if (callBack == 'success') {
                    this.setState({
                        popupState: true,
                        popupStatus: 'Comment Saved Successfully',
                        commentStateSelect: ''
                    })
                    this.removePopup();
                } else {
                    this.setState({
                        popupState: true,
                        popupStatus: 'Please try again',
                        commentStateSelect: ''
                    })
                    this.removePopup();
                }
            })
    }
    removePopup() {
        setTimeout(function () {
            this.setState({ popupState: false });
        }.bind(this), 5000)
    }
    closePopup() {
        this.setState({ popupState: false });
    }
    getLoanLead(data) {
        let dataFilterState = Object.assign({}, this.state.dataFilterState)
        dataFilterState.salaryRange = data ? data : this.state.dataFilterState.salaryRange
        this.setState({ loadarState: true, dataFilterState })
        // this.props.getManagementLeadApiOptimized(leadType, this.state.followUpStatus, this.state.forwordPageState, this.props.admin.emailId, this.state.dataFilterState.searchByDate, this.state.commentType, data ? data : '', this.state.bucketStage,
        //     (callBack) => {
        //         this.setState({ loadarState: false }, () => this.getComments())

        //     })
         const roleApi = this.props.handleRoleForApi()
        this.props.FetchLeadManagementData(leadType, this.state.followUpStatus, this.state.pageNumber, this.props.admin.emailId, this.state.dataFilterState.searchByDate, this.state.commentType, dataFilterState.salaryRange, this.state.bucketStage, this.state.dataFilterState.searchByendDate, itemsPerPage, "", "", "",roleApi,
            (callBack) => {
                this.setState({ loadarState: false, LeadData: callBack?.data?.loanList, totalLeadData: callBack?.data?.totalCount }, () => this.getComments())
            })

    }
    getData() {

    }
    phocketTablePagination(data, type) {
        if (type == 'back') {
            if (this.state.tableMinPagination >= paginationNumber) {
                this.setState({
                    tableMinPagination: this.state.tableMinPagination - paginationNumber,
                    tableMaxPagination: this.state.tableMaxPagination - paginationNumber,
                })
            }
        } else if (type == 'forward') {
            if (this.state.tableMaxPagination < data.length) {
                this.setState({
                    tableMaxPagination: this.state.tableMaxPagination + paginationNumber,
                    tableMinPagination: this.state.tableMinPagination + paginationNumber
                })
            }
        }
    }
    showWhatsappMsg(data) {
        if (data != '') {
            getWhatsappMsgApi(data.mobileNumber, 'communication', 'unread',
                (callBack) => {
                    this.setState({
                        whatsappPopupState: !this.state.whatsappPopupState,
                        whatsapMsgToShow: callBack
                    })
                })
        } else {
            this.setState({
                whatsappPopupState: false,
                whatsapMsgToShow: ''
            })
        }

    }
    nashHandler(e, incomingData) {
        const { admin } = this.props;
        saveNachDataApi(e.target.checked, incomingData.userId, admin,
            (callBack) => {
                if (callBack == 'success') {
                    this.getLoanLead()
                }
            })
    }
    getLoaderState(data) {
        this.setState({ loadarState: data })
    }
    setBucketStage(type) {
        this.setState({ bucketStage: type }, () => this.getLoanLead())
    }

    handleAllLeadData(data) {
        this.setState({ LeadData: data, totalLeadData: data?.length })
    }

    render() {
        const { admin, leadManagementDataOptimized, allStatus, newDataBackground } = this.props
        if (admin.rolelist != undefined) {
            if (admin.rolelist.indexOf(ROLE.NACH_CHANGE) >= 0) {
                nachCheckbox = true
            }
            // if (admin.rolelist.indexOf(ROLE.MARK_AS_IMPORTANT) >= 0) {
            //     markImportant = true
            // } if (admin.rolelist.indexOf(ROLE.COMMUNICATION) >= 0) {
            //     commentColumn = true
            // }
        }

        // const updatedData = leadManagementDataOptimized && leadManagementDataOptimized?.length > 0 ? leadManagementDataOptimized.map((entry1) => {
        //     const duplicateEntry = this.state.commentsData.find((entry2) => entry2.loanId === entry1.loanId);

        //     if (duplicateEntry) {
        //         return { ...entry1, adminCommentBody: duplicateEntry.adminCommentBody };
        //     } else {
        //         return entry1;
        //     }
        // }) : this.state.LeadData;

        // console.log("updated", leadManagementDataOptimized?.length)

        return (
            <div className="full-height">

                {this.state.whatsappPopupState ?
                    <WhatsAppPopup
                        messages={this.state.whatsapMsgToShow}
                        closeWhatsappPopup={this.showWhatsappMsg.bind(this)} />
                    : null}
                {this.state.userState == true ?
                    <IncompleteLeadsUi
                        countType={this.state.countType}
                        getLoanLead={this.getLoanLead.bind(this)}
                        getLoaderState={this.getLoaderState.bind(this)}
                        setBucketStage={this.setBucketStage.bind(this)}
                        bucketStage={this.state.bucketStage}
                        leadManagementCounts={this.state.leadManagementCounts}
                        forwordPageState={this.state.forwordPageState}
                        handleChangeNewPagination={this.handleChangeNewPagination.bind(this)}
                        pageNumber={this.state.pageNumber}

                        leadComment={this.state.leadComment}
                        commentType={this.state.commentType}
                        commentStateSelect={this.state.commentType}
                        nachCheckbox={nachCheckbox}
                        nashHandler={this.nashHandler.bind(this)}
                        showWhatsappMsg={this.showWhatsappMsg.bind(this)}

                        phocketTablePagination={this.phocketTablePagination.bind(this)}
                        tableMinPagination={this.state.tableMinPagination}
                        tableMaxPagination={this.state.tableMaxPagination}

                        userCommentSelect={this.userCommentSelect.bind(this)}
                        userCommentHandler={this.userCommentHandler.bind(this)}

                        countforstatus={this.state.countforstatus}

                        allUserDetail={this.state.LeadData}
                        userDetailHandler={this.userDetailHandler.bind(this)}
                        userViewHandler={this.userViewHandler.bind(this)}
                        getFilterValue={this.getFilterValue.bind(this)}
                        FilteredData={this.state.FilteredData}
                        getPageValue={this.getPageValue.bind(this)}
                        pageIndexToShow={this.state.pageIndexToShow}
                        paginationHandler={this.paginationHandler.bind(this)}
                        allStatus={allStatus}
                        dataFilterState={this.state.dataFilterState}
                        followUpStatus={this.state.followUpStatus}
                        dataFilter={this.dataFilter.bind(this)}
                        admin={admin}
                        markAsImportant={this.markAsImportant.bind(this)}
                        newDataBackground={newDataBackground}
                        loadarState={this.state.loadarState}
                        todaysApplicationNo={this.state.todaysApplicationNo}
                        showRepeateApplications={this.showRepeateApplications.bind(this)}
                        totalLeadData={this.state.totalLeadData}
                        handleAllLeadData={this.handleAllLeadData.bind(this)}
                    />
                    : null}

                {this.state.viewDetailPopupState == true ?
                    <MainDetailsPopup
                        leadManagementData={leadManagementDataOptimized}
                        getData={this.getData.bind(this)}
                        getviewDetailPopupState={this.getviewDetailPopupState.bind(this)}
                        admin={admin}
                        allDetail={this.state.viewPopupDetail}
                        userDetails={this.state.userDetail}
                    />
                    : null}

                {this.state.viewState == true ?
                    <UserDetail
                        userDetailHandler={this.userDetailHandler.bind(this)}
 handlePageState={this.props.handlePageState}
                        setDetailsPage={this.props.setDetailsPage}
                        getData={this.getData.bind(this)}
                        leadManagementData={leadManagementDataOptimized}
                        allDetail={this.state.allDetail}
                        userDetails={this.state.userDetail}
                        admin={admin}
                        backHandler={this.backHandler.bind(this)}
                        actionButtonState={this.state.actionButtonState}
                        markCompleteBtn={this.state.markCompleteBtn}
                    />
                    : ""}
                {this.state.loadarState == true ?
                    <DotLoader />
                    : ""}
                {this.state.popupState == true ?
                    <Popup
                        closePopup={this.closePopup.bind(this)}
                        popupStatus={this.state.popupStatus}
                    />
                    : ""}
            </div>
        )
    }

    markAsImportant(allDetail, isImportant) {
        const { admin } = this.props
        saveImportantLoans(allDetail, isImportant, admin.emailId,
            (callBack) => {
                this.backHandler()
            })
    }

    showRepeateApplications() {
        this.setState({
            loadarState: true,
            followUpStatus: 'repeate'
        }, () => this.getLoanLead())
    }

    dataFilter(e, chngType) {
        const { admin } = this.props
        this.setState({ loadarState: true })
        let dataFilterState = Object.assign({}, this.state.dataFilterState)
        if (chngType == 'status') {
            this.setState({ followUpStatus: e.target.value }, () => this.getLoanLead())
        } else if (chngType == 'applicationNo') {
            dataFilterState.searchByAppNo = e.target.value
            if (e.target.value.length > 4) {
                this.props.getlistByApplication(e.target.value, 1, leadType, admin, false,
                    (callBack) => {
                        this.setState({ loadarState: false })
                        this.getComments()
                    })
            }
        } else if (chngType == 'email') {
            dataFilterState.searchByemail = e.target.value
            if (e.target.value.length > 2) {
                this.props.getlistByEmail(e.target.value, 1, leadType, admin,
                    (callBack) => {
                        this.setState({ loadarState: false })
                        this.getComments()
                    })
            }
        } else if (chngType == 'mobileNo') {
            dataFilterState.searchBymobile = e.target.value
            if (e.target.value.length > 9) {
                this.props.getistByNumber(e.target.value, 1, leadType, admin,
                    (callBack) => {
                        this.setState({ loadarState: false })
                    })
            }
        } else if (chngType == "sdate") {
            dataFilterState.searchByDate = _preFormatDate(e)
            dataFilterState.searchByDateShow = e
            this.setState({
                dataFilterState
            }, () => {
                this.getLoanLead()
                this.getCount(dataFilterState.searchByDate, this.state.dataFilterState.searchByendDate)
            })
        } else if (chngType == "edate") {
            dataFilterState.searchByendDate = _preFormatDate(e)
            dataFilterState.searchByEndDateShow = e
            this.setState({
                dataFilterState
            }, () => {
                this.getLoanLead()
                this.getCount(this.state.dataFilterState.searchByDate, dataFilterState.searchByendDate)
            })
        } else if (chngType == 'comment') {
            this.setState({ commentType: e.target.value, commentStateSelect: e.target.value, leadComment: e.target.value }, () => this.getLoanLead())
        }
        if (chngType == 'salaryRange') {
            dataFilterState.salaryRange = e.target.value
            this.setState({ pageNumber: 1 },()=>{this.getLoanLead(e.target.value)})
            
        }
        if ((chngType != "sdate" || chngType != "edate") && e?.target?.value == "") {
            this.getLoanLead()
        }
        this.setState({
            dataFilterState
        })
    }

    getFilterValue(filtered) {
        this.setState({ FilteredData: filtered })
    }

    getPageValue(pageIndex) {
        this.setState({ pageIndexToShow: pageIndex })
    }

    userDetailHandler(userData) {
        logAdminApi(userData.assignUser, userData.loanId, callback => {
            console.log(callback)
        })
        this.setState({ loadarState: true })

        getUserDetailByLoanIdOptimisedApi(userData.loanId, userData.userId,
            (callBack) => {
                this.setState({
                    userState: false,
                    viewState: true,
                    allDetail: callBack,
                    userDetail: userData,
                    loadarState: false
                })
            })
        this.props.setDetailsPage(true)

    }

    userViewHandler(userData) {
        logAdminApi(userData.assignUser, userData.loanId, callback => {
            console.log(callback)
        })
        this.setState({ loadarState: true })

        if (userData.loanId != '' && userData.loanId != null) {
            getUserDetailByLoanIdOptimisedApi(userData.loanId, userData.userId,
                (callBack) => {
                    this.setState({
                        viewDetailPopupState: true,
                        viewPopupDetail: callBack,
                        userDetail: userData,
                        loadarState: false


                    })
                })
        } else {
            fetch(APIS.USER_DETAIL_BY_ID + userData.userId)
                .then(res => res.json())
                .then(res => {
                    this.setState({
                        viewDetailPopupState: true,
                        viewPopupDetail: res,
                        userDetail: data,
                        loadarState: false

                    })
                })
        }
    }

    getviewDetailPopupState(state) {
        this.setState({
            viewDetailPopupState: state,
        })
    }

    backHandler() {
        const { admin } = this.props
        this.setState({
            userState: true,
            viewState: false,
            // loadarState: true
        })
        if (this.state.dataFilterState.searchByAppNo != '') {
            this.props.getlistByApplication(this.state.dataFilterState.searchByAppNo, 1, leadType, admin, false,
                (callBack) => {
                    this.setState({
                        loadarState: false
                    })
                })
        } else if (this.state.dataFilterState.searchByemail != '') {
            this.props.getlistByEmail(this.state.dataFilterState.searchByemail, 1, leadType, admin,
                (callBack) => {
                    this.setState({
                        loadarState: false
                    })
                })
        } else if (this.state.dataFilterState.searchBymobile != '') {
            this.props.getistByNumber(this.state.dataFilterState.searchBymobile, 1, leadType, admin,
                (callBack) => {
                    this.setState({
                        loadarState: false
                    })
                })
        } else {
            if (this.state.dataChange == 'yes') {
                this.getLoanLead()
                this.setState({ dataChange: '' })
            }
        }
    }

    paginationHandler(btnType) {
        this.setState({
            loadarState: true,
            pageIndexToShow: 0
        })
        if (btnType == 'refresh') {
            let dataFilterState = Object.assign({}, this.state.dataFilterState)

            dataFilterState.searchByDate = moment(new Date()).subtract(7, 'days').format('DD-MM-YYYY')
            dataFilterState.searchByDateShow = ''
            dataFilterState.searchByendDate = moment(new Date()).format("DD-MM-YYYY")
            dataFilterState.searchByEndDateShow = ''
            this.setState({
                dataFilterState
            }, () => this.getLoanLead())
        } else if (btnType == 'back') {
            if (this.state.forwordPageState > 1) {
                this.setState({
                    forwordPageState: this.state.forwordPageState - 1,
                }, () => this.getLoanLead())
            }
        } else if (btnType == 'forward') {
            this.setState({
                forwordPageState: this.state.forwordPageState + 1,
            }, () => this.getLoanLead())
        }
    }
}

const mapStateToProps = ({ leadManagementDataOptimized }) => {
    return {
        leadManagementDataOptimized: leadManagementDataOptimized
    };
};

const mapDispatchToProps = dispatch => {
    return bindActionCreators({
        getistByNumber,
        getlistByEmail,
        getlistByApplication,
        // getManagementLeadApiOptimized,
        FetchLeadManagementData

    }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(IncompleteLeads);